import { render, staticRenderFns } from "./UserResetPasswordContainer.vue?vue&type=template&id=bb7d6238&"
import script from "./UserResetPasswordContainer.vue?vue&type=script&lang=ts&"
export * from "./UserResetPasswordContainer.vue?vue&type=script&lang=ts&"
import style0 from "./UserResetPasswordContainer.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports